import { createContext, useContext, useState, useEffect } from 'react';
import { fetchHomePage } from 'api/repository/home.api';
import { buildStorageUrl } from 'config/clientConfig';

export const HomeContext = createContext({
  sliderImages: [],
  featuredProducts: [],
  categories: [],
  deliveryCosts: {},
  loading: false,
  error: null,
});

export const HomeProvider = ({ children }) => {
  const [sliderImages, setSliderImages] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [deliveryCosts, setDeliveryCosts] = useState({});
  const [loading, setLoading] = useState(true);
  const error = null;

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        setLoading(true);
        const response = await fetchHomePage();
        const {
          banners = [],
          featuredProducts = [],
          categories = [],
          deliveryCosts = {},
        } = response.data || {};
        setSliderImages(
          banners.map((banner) => ({
            id: banner.id,  
            title: banner.title,
            image: buildStorageUrl(banner.image),
            link: banner.link,
          }))
        );
        setFeaturedProducts(featuredProducts);
        setCategories(categories);
        setDeliveryCosts(deliveryCosts);
      } catch (err) {
        console.log("Fetch failed ", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  return (
    <HomeContext.Provider
      value={{ sliderImages, featuredProducts, categories, deliveryCosts, loading, error }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export const useHome = () => useContext(HomeContext);
